import React from "react";
import PropTypes from "prop-types";
import SearchableSelect from "../common/SearchableSelect";

function ClientSettlementsReportForm({ month, monthOptions, clientId, clientOptions, showEmptyClients, onChange }) {
  return (
    <div className="mb-4">
      <div className="form-row align-items-end">
        <div className="col-md-3">
          <SearchableSelect
            label="Miesiac"
            name="month"
            value={month}
            onChange={onChange}
            options={monthOptions}
            placeholder="Wybierz miesiac"
            isClearable={false}
          />
        </div>
        <div className="col-md-4">
          <SearchableSelect
            label="Klient"
            name="clientId"
            value={clientId}
            onChange={onChange}
            options={clientOptions}
            placeholder="Wszyscy"
            clearValue="all"
          />
        </div>
        <div className="col-md-auto">
          <div className="form-group">
            <button
              type="button"
              className="btn btn-sm btn-outline-secondary"
              aria-pressed={showEmptyClients}
              onClick={() => onChange({
                target: {
                  name: "showEmptyClients",
                  value: !showEmptyClients,
                },
              })}
            >
              {showEmptyClients ? "Ukryj pustych klientow" : "Pokaz tez pustych klientow"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

ClientSettlementsReportForm.propTypes = {
  month: PropTypes.string.isRequired,
  monthOptions: PropTypes.array.isRequired,
  clientId: PropTypes.string.isRequired,
  clientOptions: PropTypes.array.isRequired,
  showEmptyClients: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default ClientSettlementsReportForm;
